import Swiper, { Navigation, Pagination, Autoplay, Keyboard, Thumbs} from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, Keyboard, Thumbs]);

const swiperThumbs = new Swiper(".sliderThumbs__swiper", {
    spaceBetween: 20,
    slidesPerView: 2,
    breakpoints: {
        992: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 5,
        },
    },
    navigation: {
        nextEl: ".sliderThumbs__next-btn",
        prevEl: ".sliderThumbs__prev-btn",
    },
});

const swiper = new Swiper(".sliderThumbs__swiper-main", {
    spaceBetween: 50,
    initialSlide: 1,
    autoHeight: true,
    navigation: {
        nextEl: ".sliderThumbs__main-next-btn",
        prevEl: ".sliderThumbs__main-prev-btn",
    },
    thumbs: {
        swiper: swiperThumbs,
    },
});